import { usePortalRef } from './portal';

export const withDiscoverContainerContext = Comp => props => {
  const { getPortalContainer } = usePortalRef();
  const container = getPortalContainer();
  return <Comp {...props} container={container} />;
};
